import MProgress from './index.vue';

MProgress.install = app => {
  app.component(MProgress.name, MProgress);
};

export default MProgress;
